<div class="global-sync-modal-root">

	<!--<div>
		<span *ngIf="networkSyncTimeRemaining === 0" style="color:red">GO! GO! GO!</span> 
	</div>-->
	<button [disabled]="modalState > 1 && modalState !== 4" (click)="close()" class="close btn btn-danger modal-btn" >X</button>

	<div *ngIf="!displayCountDown"> 
		<h1 style="height: 60px;" class="ns-header">Lifetime Timer</h1>

		<p> Please specify the amount of time you would like your service to be active for. Anyone opening your app during this time period will receive your message. 
			Also please note that publishing another message during this time period will replace the previous one.</p>


		<div class="time-container"> 
			<input (focusout)="validatePublishTime()" (ngModelChange)="validatePublishTime()" type="number" class="time-input no-outline" value="{{days}}" [(ngModel)]="days"/>
			<span class="time-unit">d</span>

			<input (focusout)="validatePublishTime()" (ngModelChange)="validatePublishTime()"  type="number" class="time-input no-outline" value="{{hours}}" [(ngModel)]="hours"/>
			<span class="time-unit">h</span>

			<input (focusout)="validatePublishTime()"  (ngModelChange)="validatePublishTime()"  type="number" class="time-input no-outline" value="{{minutes}}" [(ngModel)]="minutes"/>
			<span class="time-unit">m</span>
		</div>

		<span *ngIf="invalidPublishTime" class="m-form__help" style="padding-left: 60px; color: red;">The message lifetime must be greater than zero</span>

		<button [disabled]="invalidPublishTime" 
			(click)="publishMessage();" 
			class="startCountdown btn btn-success modal-btn" >Publish Message</button>

	</div>


	  <div *ngIf="displayCountDown && modalState === 0"> 
		<h1 class="ns-header">Welcome to CUE Audio Global Sync!</h1>

		<p> Pressing the start button will start a count down indicated by the number of seconds entered into the field on the next screen, 
			with a minimum countdown time of 10 seconds and a maximum of 60 seconds. The moment the countdown finishes, 
			all phones with your app open will sync with this service. You should start the accompanying audio or video at the exact moment when “GO!” appears at the end of the countdown. </p>
		
			<p style="border-bottom: 1px solid #e9ecef; padding-bottom: 15px;"> Once the countdown is started, it cannot be stopped! So make sure you are ready! Confirming you are ready will NOT start the show.</p>

		<div class="center-container"> 
			<div> 
				<button (click)="modalState = 1;" class="btn btn-success modal-btn" >I was born ready</button>
				<button (click)="close()" style="margin-left: 15px;" class="btn btn-danger modal-btn" >Get me out of here!</button>
			</div>
		</div>
	</div>

	<div *ngIf="displayCountDown && modalState > 0" >

		<div class="tab-container">
			<button [disabled]="modalState > 1" (click)="tabMode = 0;" [ngClass]="{ 'selected-tab': tabMode === 0, 'countdown-tab': tabMode === 1 }" class="btn">COUNTDOWN TIMER</button>
			<button [disabled]="modalState > 1" (click)="tabMode = 1;" [ngClass]="{ 'selected-tab': tabMode === 1, 'countdown-tab': tabMode === 0 }" class="btn">SCHEDULE EVENT</button>
		</div>

		<input
			*ngIf="modalState === 1 && tabMode === 0;"
			class="countdown-time"
			value="startCountdownTime"
			[(ngModel)]="startCountdownTime"
			type="number"
			step="1"
			min="10"
		/> 

		<input 
			*ngIf="modalState === 1 && tabMode === 1;"
			class="schedule-time"
			 type="time" 
			 [(ngModel)]="scheduleTime"
			 id="appt" 
			 name="appt"
			min="01:00" max="24:00">

		<select
			*ngIf="modalState === 1 && tabMode === 1;"
			class="form-control m-input time-zone-select"
			id="timeZones"
			[(ngModel)]="selectedTimeZone"
			[compareWith]="compare" 
			name="timeZones">
			<option disabled value="0">--- Select Your Timezone ---</option>
			<option *ngFor="let z of timeZones.us" [ngValue]="z.Id">
				{{z.DisplayName}}
			</option>
		  </select>
		  
		  <div *ngIf="modalState === 1 && tabMode === 1;" class="schedule-date">
			<input 
				class="form-control m-input" 
				angular-mydatepicker 
				#start="angular-mydatepicker"
				(keydown)="$event.preventDefault();" 
				(click)="start.toggleCalendar()"  
				[options]="startDateOptions"
				[(ngModel)]="startDate" 
        		[ngValue]="startDate"
				style="margin-right:0px; margin-left:10px; width: 150px;"
			/>
			<i style="position: relative; left: 128px; bottom: 32px; color: black; font-weight: bold;" (click)="start.toggleCalendar()" class="flaticon-calendar"></i>
		  </div>

		<span *ngIf="modalState === 2 && !connectionIssues" class="sync-text">Syncing{{ellipsis}}</span>
		<span *ngIf="connectionIssues" class="issues-text">Still syncing{{ellipsis}}</span>
		<span *ngIf="modalState === 3 && networkSyncTimeRemaining > 0" class="countdown-time">{{(networkSyncTimeRemaining / 1000) | number:'1.1-1'}}</span>
		<span *ngIf="modalState === 4 && tabMode === 0 && networkSyncTimeRemaining === 0" style="color:red;" class="countdown-time">GO!</span>
		<span *ngIf="modalState === 4 && tabMode === 1" style="font-size: 30px;" class="sync-text">Event scheduled!</span>

		<button [disabled]="modalState > 1 || (tabMode === 0 && (startCountdownTime < 0 || startCountdownTime > 60)) || (tabMode === 1 && (selectedTimeZone == 0 || scheduleTime === ''))" 
			(click)="startNetworkSyncModal();" 
			class="startCountdown btn btn-success modal-btn" >
			{{ tabMode === 0 ? 'Start the Countdown' : 'Schedule the Event' }}
		</button>
		
	</div>
  
</div>